/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{D1E8A715-D31D-4064-ADD2-C564C07E5F7D}",
  "sitecoreApiHost": "",
  "jssAppName": "intranet",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/Intranet",
  "graphQLEndpoint": "/api/Intranet?sc_apikey={D1E8A715-D31D-4064-ADD2-C564C07E5F7D}"
};